<template>
  <div class="import">
      <input type="file" id="csv" ref="csv" @change="handleFileUpload()" />
      <span>{{message}}</span>
      <span class="btn" @click="vSend()">VALIDER</span>
    </div>
</template>

<script>

import generalService from '../services/generalService';

export default {
  name: 'Import',
  data() {
    return {
      file: '',
      message: '',
    }
  },
  methods: {
    vSend() {
      let formData = new FormData();
      formData.append('csv', this.file);

      generalService.uploadImport(formData)
      .then(response => {
        console.error(response);
        if(response.data === true) {
          this.message = 'Import effectué avec succès';
        } else {
          this.message = 'Une erreur est survenue durant l\'import';
        }
      });
    },
    handleFileUpload() {
      this.file = this.$refs.csv.files[0];
    },
  }
}
</script>

<style scoped>
.import {
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.import span {
  margin-top: 15px;
}
</style>